/* eslint-disable no-restricted-syntax */
import detectGlobals from "../../../lib/utils/script/detectGlobals";
import { getDataPathOfAST, getMemberExpressionAt, parseJsExprSafe } from "../../../lib/utils/script/acorn";
import { splitInteropableString } from "../../../lib/utils/script/interopableString";
import { Dep } from './Dep';
/**
 * 从一段 JS 表达式 或者 插值字符串，提取出所有的 deps
 *
 * 这是一个比较原始的方法，一般不建议使用
 */
export function* getDepsFromExpression(ctx, expr, mode) {
  if (typeof expr !== 'string' || !expr) return;
  function* getDepsFromJavaScript(jsExpr, initialOffset) {
    const parseAns = parseJsExprSafe(jsExpr);
    if (parseAns.error) return;
    // 坐标位置的补偿
    const offset = -parseAns.offset + initialOffset;
    const astRoot = parseAns.ast;
    const globals = detectGlobals(astRoot);
    for (const global of globals) {
      if (!ctx.globalVariables.has(global.name)) continue;
      for (const node of global.nodes) {
        const memberExpression = getMemberExpressionAt(astRoot, node.start);
        if (!memberExpression) continue;
        const dataPath = getDataPathOfAST(memberExpression);
        if (!dataPath) continue;
        yield new Dep({
          dataPath,
          description: '表达式有依赖',
          start: memberExpression.start + offset,
          end: memberExpression.end + offset,
          place: []
        });
      }
    }
  }
  // 1. 收集那些是 JS 表达式的片段
  if (mode === 'javascript') {
    yield* getDepsFromJavaScript(expr, 0);
  }
  if (mode === 'interopable-string') {
    const {
      parts,
      offsets
    } = splitInteropableString(expr);
    for (let i = 1; i < parts.length; i += 2) {
      const expr = parts[i];
      const offset = offsets[i];
      yield* getDepsFromJavaScript(expr, offset);
    }
  }
}
//# sourceMappingURL=getDepsFromExpression.js.map
